import axios from '~/utils/axios';

export const beginSmsOtpChallenge = () => {
  return axios.post(`/auth/smsotp/beginChallenge`);
};

export const exchangeCodeToTokens = (code: string) => {
  return axios.post(`/auth/exchangeCode?referrer_uri=${window.location.origin}/auth/redirect`, {
    code,
  });
};

export const refreshToken = (refreshToken: string) => {
  return axios.post(`/auth/refreshToken?referrer_uri=${window.location.origin}/auth/redirect`, {
    refreshToken,
  });
};

export const logout = (refreshToken: string) => {
  return axios.post(`/auth/logout?referrer_uri=${window.location.origin}/auth/redirect`, {
    refreshToken,
  });
};
